import { useState } from "react";

const channels = [
  { key: "baoliao", icon: "ri-flashlight-fill", label: "吃瓜爆料" },
  { key: "qing", icon: "ri-chat-private-line", label: "私信倾诉" },
  { key: "shuo", icon: "ri-megaphone-line", label: "我想说" },
];

export default function PostForm() {
  const [cat, setCat] = useState("baoliao");
  const [sent, setSent] = useState(false);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSent(true);
  };

  return (
    <section id="post" className="w-full bg-red-700 py-12 md:py-16">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="grid gap-8 lg:grid-cols-[0.9fr_1.1fr] lg:items-center">
          <div className="text-white">
            <p className="flex items-center gap-2 text-xs font-bold tracking-widest text-amber-300">
              <i className="ri-send-plane-fill"></i> 52 爆料投稿 / 私信渠道
            </p>
            <h2 className="mt-3 text-3xl font-black leading-snug md:text-4xl">
              有话说，别憋着。<br />
              投稿或私信，我帮你<span className="text-amber-400">发上墙</span>。
            </h2>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-red-100">
              在这里投的内容会被整理上墙，让更多人看见、接住。若是只想悄悄说，选「私信倾诉」，匿名的我替你保管。
            </p>

            <ul className="mt-6 space-y-2.5 text-sm text-red-50">
              <li className="flex items-center gap-2">
                <i className="ri-checkbox-circle-fill text-amber-400"></i> 全程匿名，绝不公开投稿人身份
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-checkbox-circle-fill text-amber-400"></i> 热门投稿优先上榜、优先回复
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-checkbox-circle-fill text-amber-400"></i> 违规内容先审后发，绝不乱上墙
              </li>
            </ul>
          </div>

          <div className="rounded-3xl bg-white p-5 shadow-2xl shadow-red-950/20 md:p-7">
            {sent ? (
              <div className="flex min-h-[380px] flex-col items-center justify-center text-center">
                <span className="flex h-16 w-16 items-center justify-center rounded-full bg-emerald-100 text-emerald-600">
                  <i className="ri-check-line text-3xl"></i>
                </span>
                <h3 className="mt-5 text-xl font-black text-stone-800">收到啦！这就帮你安排上墙</h3>
                <p className="mt-2 max-w-sm text-sm text-stone-500">
                  内容已进入审核排队（演示环境，不会真实提交）。想上热搜榜，记得选个够劲的分区。
                </p>
                <button
                  onClick={() => setSent(false)}
                  className="mt-6 rounded-full border border-red-200 px-5 py-2 text-sm font-semibold text-red-600 transition hover:bg-red-50"
                >
                  再投一条
                </button>
              </div>
            ) : (
              <form onSubmit={handleSubmit}>
                <h3 className="text-lg font-black text-stone-800">我要投稿上墙</h3>

                <div className="mt-4 grid grid-cols-3 gap-2">
                  {channels.map((c) => (
                    <button
                      type="button"
                      key={c.key}
                      onClick={() => setCat(c.key)}
                      className={`flex flex-col items-center gap-1.5 rounded-xl border px-2 py-3 text-xs font-semibold transition ${
                        cat === c.key
                          ? "border-red-600 bg-red-50 text-red-700"
                          : "border-stone-200 text-stone-500 hover:border-red-200"
                      }`}
                    >
                      <i className={`${c.icon} text-lg`}></i>
                      {c.label}
                    </button>
                  ))}
                </div>

                <div className="mt-4 grid gap-3 sm:grid-cols-2">
                  <input
                    name="nickname"
                    type="text"
                    placeholder="给个匿名昵称（可空）"
                    className="rounded-xl border border-stone-200 bg-stone-50 px-3 py-2.5 text-sm outline-none focus:border-red-400 focus:bg-white"
                  />
                  <input
                    name="email"
                    type="email"
                    placeholder="接收上墙通知的邮箱（可空）"
                    className="rounded-xl border border-stone-200 bg-stone-50 px-3 py-2.5 text-sm outline-none focus:border-red-400 focus:bg-white"
                  />
                </div>

                <textarea
                  name="content"
                  required
                  maxLength={500}
                  rows={4}
                  placeholder="想说点什么？瓜料、心事、表白、吐槽…… 150 字左右最容易被接住～"
                  className="mt-3 w-full resize-none rounded-xl border border-stone-200 bg-stone-50 px-3 py-2.5 text-sm leading-relaxed outline-none focus:border-red-400 focus:bg-white"
                ></textarea>

                {/* honeypot 防垃圾（不可见） */}
                <input
                  type="text"
                  name="company_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="hp-field"
                />

                <button
                  type="submit"
                  className="mt-4 flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full bg-red-600 px-5 py-3 text-sm font-bold text-white transition hover:bg-red-700"
                >
                  <i className="ri-send-plane-fill"></i>
                  帮我发上墙（匿名）
                </button>
                <p className="mt-2 text-center text-[11px] text-stone-400">
                  提交即表示同意按匿名规范处理，违规内容不会展示。
                </p>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}